<template>
  <Row>
    <i-col span="24">
      <AffixHeader>
        <span slot="current">Portfolios</span>
        <span slot="title">Portfolios</span>
      </AffixHeader>

      <AgGridVue
        style="width: 100%; height: 840px;"
        class="ag-theme-balham"
        :gridOptions="gridOptions"
        :columnDefs="gridColumns"
        :rowData="portfolios"
        @onGridReady="onGridReady"
      ></AgGridVue>
    </i-col>
  </Row>
</template>

<script>
import axios from "axios";
import { getUserOptionsByRole, getUserOptions, getUser } from "@/models/User";
import { getAllPortfolios, setPortfolio } from "@/models/Portfolio";
import { AgGridVue } from "ag-grid-vue";

export default {
  components: {
    AgGridVue,
  },
  data() {
    return {
      portfolios: [],
      users: [],
    };
  },
  mounted() {
    this.loadPortfolios();
  },
  computed: {
    gridOptions() {
      return {
        sideBar: false,
        enableRangeSelection: true,
        // enablePivot: true,
        defaultColDef: {
          sortable: true,
          resizable: true,
          filter: true,
        },
        onGridReady: params => {
          params.api.sizeColumnsToFit();
        },
      };
    },
    gridColumns() {
      return [
        {
          headerName: "Country",
          field: "geo_name",
          enableRowGroup: true,
        },
        {
          headerName: "Group",
          field: "geo_group",
          enableRowGroup: true,
        },
        {
          headerName: "Monitoring Experts",
          field: "user",
          valueFormatter({ value }) {
            return typeof value === "string" ? value : value.name;
          },
          enableRowGroup: true,
          editable: this.$can("manage", "portfolios"),
          cellEditor: "agRichSelectCellEditor",
          cellEditorParams: () => {
            return {
              values: this.users,
              formatValue: user =>
                typeof user === "string" ? user : user.name,
            };
          },
          onCellValueChanged: params => {
            const { newValue, oldValue, data } = params;
            const isSelect = typeof newValue !== "string";
            const isChanged = newValue.username !== oldValue;
            if (isSelect && isChanged) {
              this.updatePortfolio(data.iso3, newValue.username);
            }
          },
        },
        {
          headerName: "Since",
          field: "assigned_at",
        },
        {
          headerName: "By",
          field: "assigned_by",
        },
      ];
    },
  },
  async created() {
    this.users = getUserOptions();
  },
  methods: {
    async loadPortfolios() {
      try {
        this.portfolios = await getAllPortfolios();
      } catch (error) {
        this.portfolios = [];
        console.error(error);
      }
    },
    async updatePortfolio(iso3, username) {
      this.gridOptions.api.showLoadingOverlay();
      try {
        await setPortfolio(iso3, username);
      } catch (error) {
        console.error(err);
      }
      this.loadPortfolios();
    },
    onGridReady(params) {
      params.api.sizeColumnsToFit();
    },
  },
};
</script>

<style></style>
